import { createFileRoute } from "@tanstack/react-router";

import { SitePicker } from "../../../../areas/owner/home/OwnerPages";

/** `/portal/sites`: the picker, always (the header's "Cambiar de sitio", FR-FE12-03). */
export const Route = createFileRoute("/portal/_owner/sites/")({
  component: SitePicker,
});
